import { gql, TypedDocumentNode } from '@common/hooks';
import { FullValidationErrorFragment } from '@common/graphql/fragments';

type ApprovalsEditDrawerMutationResponse = {
  createApprovalTemplate: {
    errors: object;
  };
};

type ApprovalChainTemplateMutationType = {
  id?: string;
  destroy?: boolean;
  approvalChainStepTemplates: {
    id?: string;
    destroy?: boolean;
    approvalChainApproverTemplates: {
      id?: string;
      worksMembershipId: string;
      destroy?: boolean;
    }[];
  }[];
};

type ApprovalsEditDrawerMutationVariables = {
  input: {
    organizationUnitId: string;
    actionType: string;
    approvalChainTemplates: ApprovalChainTemplateMutationType[];
    preApproved: boolean;
  };
};

export const ApprovalsEditDrawerMutation: TypedDocumentNode<
  ApprovalsEditDrawerMutationResponse,
  ApprovalsEditDrawerMutationVariables
> = gql`
  mutation CreateApprovalTemplateMutation($input: ApprovalsInput!) {
    createApprovalTemplate(input: $input) {
      organizationUnit {
        id
        approvalChainTemplates {
          id
          actionType
          approvalChainStepTemplates {
            id
            approvalChainApproverTemplates {
              id
              worksMembership {
                id
                name
              }
            }
          }
        }
      }
      errors {
        ...FullValidationErrorFragment
      }
    }
  }
  ${FullValidationErrorFragment}
`;
